import { createFileRoute } from '@tanstack/react-router';
import {
  creditProductDetailScreen,
  creditProductDetailSearch,
  loadCreditProductMessages,
  loadCreditProductScreens,
} from '@/modules/credit-product/route';
import { lazyScreen } from '@/shared/screen';
export const Route = createFileRoute('/_app/cadastro/produtos-credito/$productId/')({
  validateSearch: creditProductDetailSearch,
  staticData: { screen: creditProductDetailScreen },
  loader: loadCreditProductMessages,
  component: lazyScreen(loadCreditProductScreens, 'CreditProductFormPage'),
});
